import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { PageHeader } from '@ipfabric/ui-components/PageHeader/PageHeader';
import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import { SnmpForm } from './SnmpForm';
import type { Snmp as SnmpValues } from './model/SnmpModel';
import { useSnmp } from './model/useSnmp';

const Snmp = () => {
  const snmp = useSnmp();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Runs only once
  useEffect(() => {
    snmp.actions.loadSnmp();
  }, []);

  const handleSubmit = (values: SnmpValues) => {
    snmp.actions.saveSnmp(values);
  };

  if (snmp.model.loading) {
    return (
      <div className='box box-solid mb-0 flex flex-1 items-center'>
        <LoaderAndText />
      </div>
    );
  }

  return (
    <div className='flex flex-col items-center'>
      <Helmet title='SNMP' />
      <PageHeader elevated width='content-default' label='SNMP' />
      <div className='w-full max-w-content-default flex flex-col px mt mb gap'>
        <SnmpForm
          initialValues={snmp.model.values}
          onSubmit={handleSubmit}
          loading={snmp.model.submitting}
        />
      </div>
    </div>
  );
};

export default Snmp;
